<script setup lang="ts">
/* @ts-ignore eslint-disable */
import { useRegisterSW } from 'virtual:pwa-register/vue'

const { needRefresh, updateServiceWorker } = useRegisterSW()
</script>

<template>
  <!-- background overlay -->
  <div v-if="needRefresh" class="modal-backdrop fade show"></div>
  <!-- alerta centro de pantalla -->
  <div v-if="needRefresh" class="alert-danger alert position-fixed top-50 start-50 translate-middle w-75 fade show"
    style="z-index: 9999">
    <div class="alert-heading text-center">
      <i class="bi bi-arrow-repeat fs-1 me-2" style="font-size: 2rem"></i>
      <h2 class="fw-semibold">¡Actualización disponible!</h2>
    </div>
    <div class="mb-3 text-center">
      <span> Hay una nueva versión disponible. </span>
    </div>
    <div class="d-flex justify-content-center">
      <button v-if="needRefresh" @click="updateServiceWorker()" class="btn btn-danger btn-lg">
        Actualizar
      </button>
    </div>
  </div>
</template>
<style scoped>
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border-color: #f5c6cb;
}

.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
  border-color: #bee5eb;
}
</style>
